import { Component, ElementRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { InMessageCarousel } from './models';
import { API_URL_PREFIX } from '../../services/basic.service';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';

@Component({
  selector: 'app-message-inmessage-carousel',
  templateUrl: './message-inmessage-carousel.component.html',
  styleUrls: ['./message-inmessage-carousel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageInmessageCarouselComponent implements OnInit {
  @Input() carousel: InMessageCarousel;

  slideIndex = 0;
  maxSlideIndex = 0;
  pictureURL = `${API_URL_PREFIX}/${this.alcmeonContextService.companyId}/pictures/`;

  constructor(private elementRef: ElementRef, private alcmeonContextService: AlcmeonContextService) {}

  ngOnInit(): void {
    this.maxSlideIndex = (this.carousel.slides || []).length;
  }

  scrollToPreviousSlide() {
    this.scrollToSlide(--this.slideIndex);
  }
  scrollToNextSlide() {
    this.scrollToSlide(++this.slideIndex);
  }

  scrollToSlide(index, forced?: boolean) {
    if (index < 0 || index >= this.maxSlideIndex) {
      return;
    }
    if (forced) {
      this.slideIndex = index;
    }
    const carouselInner = this.elementRef.nativeElement.querySelector('.carousel-container');

    const slideWidth = this.elementRef.nativeElement.querySelector('.slide').clientWidth;
    const offset = index * (+slideWidth + 10);

    carouselInner['style'].transform = `translateX(-${offset}px)`;
  }
}
